import { AddCountryComponent } from '../pages/list/geo-data/add-country/add-country.component';
import { AddGeoDistrictComponent } from '../pages/list/geo-data/add-geo-district/add-geo-district.component';
import { AddGeoProvinceComponent } from '../pages/list/geo-data/add-geo-province/add-geo-province.component';
import { AddHolidayComponent } from '../pages/list/holiday/add-holiday/add-holiday.component';
import { AddShiftComponent } from '../pages/list/shift/add-shift/add-shift.component';
import { AddSessionComponent } from '../pages/list/shift/add-session/add-session.component';
import { AddTermComponent } from '../pages/list/shift/add-term/add-term.component';
import { AddSubjectComponent } from '../pages/list/subject/add-subject/add-subject.component';
import { AddProgramComponent } from '../pages/list/programs/add-program/add-program.component';
import { AddDegreeComponent } from '../pages/list/degree/add-degree/add-degree.component';
import { AddLevelComponent } from '../pages/list/level/add-level/add-level.component';
import { AddTrainingLevelComponent } from '../pages/list/training-level/add-training-level/add-training-level.component';
import { AddTrainingProgramComponent } from '../pages/list/training-program/add-training-program/add-training-program.component';
import { AddNationalityComponent } from '../pages/list/nationality/add-nationality/add-nationality.component';
import { AddCampusComponent } from '../pages/list/campus/add-campus/add-campus.component';
import { AddRoomComponent } from '../pages/list/room/add-room/add-room.component';
import { AddBuildingComponent } from '../pages/list/building/add-building/add-building.component';
import { AddFloorComponent } from '../pages/list/floor/add-floor/add-floor.component';
import { AddRoomTypeComponent } from '../pages/list/room-types/add-room-type/add-room-type.component';
import { AddLectureTypeComponent } from '../pages/list/lecture-type/add-lecture-type/add-lecture-type.component';
import { AddFacultyComponent } from '../pages/list/faculty/add-faculty/add-faculty.component';
import { AddMajorComponent } from '../pages/list/faculty/add-major/add-major.component';
import { AddCurricularComponent } from '../pages/list/faculty/add-curricular/add-curricular.component';
import { AddCourseTypeComponent } from '../pages/list/course-type/add-course-type/add-course-type.component';
import { AddCurriculumCourseComponent } from '../pages/list/faculty/add-curriculum-course/add-curriculum-course.component';
import { AddScheduleComponent } from '../pages/enrollment/schedule/add-schedule/add-schedule.component';
import { UpdateScheduleComponent } from '../pages/enrollment/schedule/update-schedule/update-schedule.component';
import { AddEnrollReadingComponent } from '../pages/enrollment/enroll-reading/add-enroll-reading/add-enroll-reading.component';

export const APP_ENTRIES=[
    AddCountryComponent,
    AddGeoDistrictComponent,
    AddGeoProvinceComponent,
    AddHolidayComponent,
    AddShiftComponent,
    AddSessionComponent,
    AddTermComponent,
    AddSubjectComponent,
    AddProgramComponent,
    AddDegreeComponent,
    AddSubjectComponent,
    AddLevelComponent,
    AddTrainingLevelComponent,
    AddTrainingProgramComponent,
    AddNationalityComponent,
    AddCampusComponent,
    AddRoomComponent,
    AddBuildingComponent,
    AddFloorComponent,
    AddRoomTypeComponent,
    AddLectureTypeComponent,
    AddFacultyComponent,
    AddMajorComponent,
    AddCurricularComponent,
    AddCourseTypeComponent,
    AddCurriculumCourseComponent,
    AddScheduleComponent,
    UpdateScheduleComponent,
    AddEnrollReadingComponent
]